module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.f519ac7.woff";